import type { StoreApi, UseBoundStore } from 'zustand';
import type { Locale } from '@/i18n/config';
import { defaultLocale, isValidLocale } from '@/i18n/config';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

function getPersistedLocale(): Locale {
  if (typeof window === 'undefined') return defaultLocale;
  const stored = localStorage.getItem('preferred-locale');
  if (stored !== null && isValidLocale(stored)) return stored;
  return defaultLocale;
}

export const useLocaleStore: UseBoundStore<StoreApi<LocaleState>> = createTrackedStore<LocaleState>(
  'useLocaleStore',
)((set) => ({
  locale: getPersistedLocale(),
  setLocale: (locale: Locale): void => {
    set({ locale });
  },
}));
